<template>
  <div>
    <div v-html="marketplaceIcon(mpId)"></div>
    <apexchart :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { marketplaceIcon } from "@/utils/helper";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    mpId: String,
    propSeries3: Array
  },
  data() {
    return {
      series: this.propSeries3,
      chartOptions: {
        chart: {
          type: "donut"
        },
        labels: ["Raw", "In Progress", "Need Review", "Reopen", "Closed"],
        colors: ["#E31E52", "#fccd00", "#03AC0E", "#EE4D2D", "#1890FF"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        title: {
          // text: `Total Per Status ${this.mpId.charAt(0).toUpperCase() +
          //   this.mpId.slice(1)}`,
          style: {
            fontFamily: "CircularStd",
            fontSize: "20px",
            fontWeight: 500
          }
        },
        noData: {
          text: "Tidak ada data yang tersedia"
        }
      }
    };
  },
  methods: {
    marketplaceIcon(value) {
      return marketplaceIcon(value);
    }
  }
};
</script>

<style>
.apexcharts-legend-text {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/summary/components/totalStatusPerMP.vue